module.exports = __webpack_public_path__ + "static/media/liaoyang-1@2x.c4c10843.png";